import { BookingNewContext } from '../../bookingNewContext'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { getUserDefaultDepartment, getUserDefaultDepartmentByOffice } from '@/api/user'

/**
 * BookingWorkspace的Context
 */
export class PredictionWorkspaceContext extends BookingNewContext {
  /**
   * constructor
   */
  constructor(obj) {
    super(obj)
    if (!(obj instanceof PredictionWorkspaceContext)) {
      this._data.userList = null
      this._data.companyList = null
      this._data.seaPortList = null
      this._data.regionList = null
      this._data.paymentTermList = null
      this._data.packingList = null
      this._data.shippingTermList = null
      this._data.blModeList = null
      this._data.defaultSeaImportJob = null
      this._data.opDepartment = null
      this._data.modifiedData = {} // 在页面中看不到，但被联动修改了的实体数据
      this._data._activeCmpList = [] // 活跃或正在使用中的合作伙伴列表
    }
  }
  get userList() {
    return this._data.userList
  }
  set userList(userList) {
    this._data.userList = userList
  }
  get companyList() {
    return this._data.companyList
  }
  set companyList(companyList) {
    this._data.companyList = companyList
  }
  get seaPortList() {
    return this._data.seaPortList
  }
  set seaPortList(seaPortList) {
    this._data.seaPortList = seaPortList
  }
  get regionList() {
    return this._data.regionList
  }
  set regionList(regionList) {
    this._data.regionList = regionList
  }
  get paymentTermList() {
    return this._data.paymentTermList
  }
  set paymentTermList(paymentTermList) {
    this._data.paymentTermList = paymentTermList
  }
  get packingList() {
    return this._data.packingList
  }
  set packingList(packingList) {
    this._data.packingList = packingList
  }
  get shippingTermList() {
    return this._data.shippingTermList
  }
  set shippingTermList(shippingTermList) {
    this._data.shippingTermList = shippingTermList
  }
  get blModeList() {
    return this._data.blModeList
  }
  set blModeList(blModeList) {
    this._data.blModeList = blModeList
  }
  get defaultSeaImportJob() {
    return this._data.defaultSeaImportJob
  }
  set defaultSeaImportJob(defaultSeaImportJob) {
    this._data.defaultSeaImportJob = defaultSeaImportJob
  }
  get opDepartment() {
    return this._data.opDepartment
  }
  set opDepartment(opDepartment) {
    this._data.opDepartment = opDepartment
  }
  get modifiedData() {
    return this._data.modifiedData
  }
  set modifiedData(modifiedData) {
    this._data.modifiedData = modifiedData
  }
  /**
   * 获取实例
   */
  static getInstance() {
    if (!this._instance) {
      this._instance = new PredictionWorkspaceContext(super.getInstance())
    }
    return this._instance
  }
  /**
   * 准备好数据
   */
  async prepareData() {
    await super.prepareData()
    this.userList = await getSpecificBasicData(basicCacheKeys.basic_data_User)
    this.companyList = await getSpecificBasicData(basicCacheKeys.basic_data_Company)
    this.seaPortList = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    this.regionList = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
    this.paymentTermList = await getSpecificBasicData(basicCacheKeys.basic_data_PaymentTerm)
    this.packingList = await getSpecificBasicData(basicCacheKeys.basic_data_Packing)
    this.shippingTermList = await getSpecificBasicData(basicCacheKeys.basic_data_ShippingTerm)
    this.blModeList = await getSpecificBasicData(basicCacheKeys.basic_data_BlMode)
  }
  getCompanyById(cmpIdx) {
    if (!this.companyList) {
      return null
    }
    const activeCmpList = this._data._activeCmpList
    let cmp = activeCmpList.find(p => p.cmpIdx === cmpIdx)
    if (!cmp) {
      cmp = this.companyList.find(p => p.cmpIdx === cmpIdx)
      if (cmp) {
        activeCmpList.push(cmp)
      }
    }
    return cmp
  }
  async getDefaultSeaImportJob() {
    const entityDefValUtil = EntityDefaultValueUtil.getInstance()
    if (!entityDefValUtil.defaultValues) {
      await entityDefValUtil.initEntityDefaultValue()
    }
    this.defaultSeaImportJob = entityDefValUtil.seaImportJob.getData()
  }
  async getOpDepartment() {
    if (!this.opDepartment) {
      this.opDepartment = await getUserDefaultDepartment({ category: 'role', shape: 'siop' }).then(res => res.data)
    }
  }
  async getCurrentOfficeOpDepartment(userId, officeId) {
    if (!this.opDepartment) {
      this.opDepartment = await getUserDefaultDepartmentByOffice({ category: 'role', shape: 'siop', userId, officeId }).then(res => res.data)
    }
  }
}
